import { createFileRoute } from '@tanstack/react-router'
import { FeaturesConfigSection } from '~/features/webchat/components'

export const Route = createFileRoute('/workspaces/$workspaceId/bots/$botId/webchat/v2/features')({
  component: Component,
})

function Component() {
  const { workspaceId, botId } = Route.useParams()

  return <FeaturesConfigSection workspaceId={workspaceId} botId={botId} />
}
